<template>
  <div class="b24">
    <!-- Hero -->
    <div class="section py-0 club-waitlist-hero">
      <div class="site-width">
        <div class="row hero hero--5-7 text-white">
          <div class="columns hero__copy">
            <h1 class="sr-only">The Waitlist</h1>
            <img src="~/assets/images/club-waitlist-logo.png" alt="" />
          </div>
          <div class="columns hero__image">&nbsp;</div>
        </div>
      </div>
    </div>
    <!-- /Hero -->
    <div class="section py-0">
      <div class="site-width">
        <div
          class="row callout callout--cutoutimagecopy small-reverse small-button-bottom"
        >
          <div class="columns callout__image">
            <img
              v-if="pageContent.food_image_1"
              :src="pageContent.food_image_1"
              alt=""
            />
            <img
              v-else
              src="~/assets/images/club-waitlist-photo2-2.png"
              alt=""
            />
          </div>
          <div class="columns callout__copy">
            <h2>
              An exclusive subscription to world-class wines curated by culinary
              icons.
            </h2>
            <button v-if="hasMembership && isAccepted" class="button primary">
              Currently Enrolled
            </button>
            <button v-else-if="hasMembership" class="button primary">
              On the Waitlist
            </button>
            <button v-else class="button primary" @click="signup()">
              Join Now
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="section club-waitlist-masonry-container">
      <div class="site-width">
        <div class="copyblock medium-text-center">
          <h2 class="fhead1">
            James Beard Awards, Michelin Stars,
            <br class="d-none medium-show" />
            The World’s 50 Best.
          </h2>
          <p class="fparagraph1">
            We’re ushering you into the most exclusive kitchens and dining rooms
            in the world.
          </p>
        </div>
        <div class="row grid-masonry xlarge-10 grid-masonry--masonry1">
          <div class="columns">
            <img
              v-if="pageContent.restaurant_image"
              :src="pageContent.restaurant_image"
              alt=""
            />
            <img
              v-else
              src="~/assets/images/club-waitlist-photo3.webp"
              alt="Chefs Emeril Lagasse and E.J. Lagasse—named Chef Patron of Emeril’s in 2022"
            />
          </div>
          <div class="columns grid-masonry__copy shade">
            <h3 class="f17 mb-6">Upcoming Shipment</h3>
            <h4 v-if="pageContent.restaurant_name" class="f17">
              {{ pageContent.restaurant_name }}
            </h4>
            <h4 v-else class="f17">Emeril's</h4>
            <p
              v-if="pageContent.restaurant_description"
              v-html="pageContent.restaurant_description"
            ></p>
            <p v-else>
              The New Orleans flagship of chef Emeril Lagasse has been
              delighting diners for 34 years, ever since he saw the potential in
              a dimly lit industrial neighborhood full of abandoned buildings.
              Over 34 years, the Emeril’s wine program has earned high honors:
              It first took home
              <em>Wine Spectator’s</em>
              coveted Grand Award in 2000, cementing the list as one of the
              world’s best.
            </p>
            <p class="mb-6">
              <strong>Past Shipments</strong>
            </p>
            <ul class="f17">
              <li
                v-if="pageContent.past_shipment_text_1"
                v-html="pageContent.past_shipment_text_1"
              ></li>
              <li v-else>
                <strong>Atomix</strong>, #6 on World’s 50 Best (highest ranked
                US)
              </li>
              <li
                v-if="pageContent.past_shipment_text_2"
                v-html="pageContent.past_shipment_text_2"
              ></li>
              <li v-else>
                <strong>Restaurant DANIEL</strong>, Daniel Boulud’s two-Michelin
                starred flagship
              </li>
            </ul>
          </div>
          <div class="columns">
            <img
              v-if="pageContent.past_shipment_image_1"
              :src="pageContent.past_shipment_image_1"
              alt=""
            />
            <img
              v-else
              src="~/assets/images/club-waitlist-photo4.webp"
              alt="Chef Junghyun Park"
            />
          </div>
          <div class="columns">
            <img
              v-if="pageContent.past_shipment_image_2"
              :src="pageContent.past_shipment_image_2"
              alt=""
            />
            <img
              v-else
              src="~/assets/images/club-waitlist-photo5.webp"
              alt="Chef Daniel Boulud"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="club-waitlist-illustration">
      <div class="site-width">
        <div class="club-waitlist-illustration__image">
          <img src="~/assets/images/club-waitlist-photo6.svg" alt="" />
        </div>
      </div>
    </div>
    <div class="section pb-0">
      <div class="site-width text-center">
        <div
          class="row grid-imagecopy images-round small-stack medium-stagger large-3up"
        >
          <div class="columns">
            <h2 class="fhead1">Your Experience Awaits</h2>
            <ul class="grid-imagecopy__list">
              <li>
                <div class="grid-imagecopy__image">
                  <img
                    v-if="pageContent.world_renowned_wines_image"
                    :src="pageContent.world_renowned_wines_image"
                    alt=""
                  />
                  <img
                    v-else
                    src="~/assets/images/club-waitlist-photo7.webp"
                    alt=""
                  />
                </div>
                <div class="grid-imagecopy__copy">
                  <strong>World-Renowned Wines</strong>
                  Curated by the experts at Wine Access, showcasing each
                  restaurant’s wine program.
                </div>
              </li>
              <li>
                <div class="grid-imagecopy__image">
                  <img
                    v-if="pageContent.perfect_pairings_image"
                    :src="pageContent.perfect_pairings_image"
                    alt=""
                  />
                  <img
                    v-else
                    src="~/assets/images/club-waitlist-photo8.webp"
                    alt=""
                  />
                </div>
                <div class="grid-imagecopy__copy">
                  <strong>Perfect Pairings</strong>
                  Recommendations from the world’s most decorated chefs included
                  in every shipment
                </div>
              </li>
              <li>
                <div class="grid-imagecopy__image">
                  <img
                    v-if="pageContent.exclusive_events_image"
                    :src="pageContent.exclusive_events_image"
                    alt=""
                  />
                  <img
                    v-else
                    src="~/assets/images/club-waitlist-photo9.webp"
                    alt=""
                  />
                </div>
                <div class="grid-imagecopy__copy">
                  <strong>Exclusive Events</strong>
                  Access to one-of-a-kind chef’s table and winemaker dinners,
                  private dining, and more.
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="copyblock copyblock--featuresummary club-waitlist-featuresummary"
        >
          <ul class="undecorated">
            <li>
              <strong>{{ deliveryFrequency }}</strong>
            </li>
            <li>
              <strong>{{ pricingInfo }}</strong>
            </li>
            <li>Complimentary Shipping</li>
          </ul>
          <div class="copyblock__listhead">
            <strong>Plus:</strong>
          </div>
          <ul class="undecorated">
            <li>Receive 10% off all Wine Access purchases *</li>
            <li>Easily reschedule, skip, or cancel.</li>
            <li>
              Enjoy free shipping on any wine you add to a wine club order.
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="section pt-0">
      <div class="scroller scroller--bottlehover text-center">
        <h3>Past Selections</h3>
        <ul>
          <li>
            <div class="scroller--bottlehover__item">
              <img
                src="~/assets/images/rhys_chardonnay_anderson_valley.webp"
                alt=""
              />
              <span class="scroller--bottlehover__hover">
                <div class="scroller--bottlehover__copy">
                  <span class="scroller__title"
                    >2021 Rhys Vineyards Chardonnay Anderson Valley</span
                  >
                  <span class="scroller__narrative"
                    >A Chardonnay without limits</span
                  >
                </div>
              </span>
            </div>
          </li>
          <li>
            <div class="scroller--bottlehover__item">
              <img
                src="~/assets/images/eric_maitre_blanc_de_noirs_brut_tradition_champagne.webp"
                alt=""
              />
              <span class="scroller--bottlehover__hover">
                <div class="scroller--bottlehover__copy">
                  <span class="scroller__title"
                    >NV Eric Maitre Blanc de Noirs Brut Tradition
                    Champagne</span
                  >
                  <span class="scroller__narrative"
                    >Sustainably farmed Champagne with laser-like
                    precision</span
                  >
                </div>
              </span>
            </div>
          </li>
          <li>
            <div class="scroller--bottlehover__item">
              <img src="~/assets/images/diego_conterno_barolo.webp" alt="" />
              <span class="scroller--bottlehover__hover">
                <div class="scroller--bottlehover__copy">
                  <span class="scroller__title"
                    >2019 Diego Conterno Barolo DOCG Piedmont</span
                  >
                  <span class="scroller__narrative"
                    >Galloni: “Check out these wines before they become better
                    known”</span
                  >
                </div>
              </span>
            </div>
          </li>
          <li>
            <div class="scroller--bottlehover__item">
              <img
                src="~/assets/images/alex_foillard_cote_de_brouilly_beaujolais.webp"
                alt=""
              />
              <span class="scroller--bottlehover__hover">
                <div class="scroller--bottlehover__copy">
                  <span class="scroller__title"
                    >2020 Alex Foillard Cote de Brouilly Beaujolais</span
                  >
                  <span class="scroller__narrative"
                    >Organic, electrically fruity Beaujolais from regional
                    royalty</span
                  >
                </div>
              </span>
            </div>
          </li>
        </ul>
      </div>
      <div class="section py-0">
        <div class="site-width">
          <div class="rule"></div>
          <div
            class="row callout callout--cutoutimagecopy valign-center medium-reverse copy-left xlarge-imgl-negcol1"
          >
            <div class="columns callout__image col-4">
              <img
                v-if="pageContent.secure_your_place_image"
                :src="pageContent.secure_your_place_image"
                alt=""
              />
              <img
                v-else
                src="~/assets/images/club-waitlist-photo10.webp"
                alt=""
              />
            </div>
            <div class="columns callout__copy">
              <h2>Secure your place.</h2>
              <p>
                To give members access to the most tightly allocated,
                hardest-to-find wines possible, we will be limiting membership.
                Access is on a first-come first-serve basis.
              </p>
              <button v-if="hasMembership && isAccepted" class="button primary">
                Currently Enrolled
              </button>
              <button v-else-if="hasMembership" class="button primary">
                On the Waitlist
              </button>
              <button v-else class="button primary" @click="signup()">
                Join The Waitlist
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ga4 from '#common/utils/ga4'

export default {
  name: 'TheWaitlistIndex',
  async setup() {
    const { data: waitlistData } = await useAsyncData('waitlist', () =>
      $fetch('/api/membership/waitlist/'),
    )

    return {
      deliveryFrequency: computed(
        () => waitlistData.value?.delivery_freq_info || '',
      ),
      pricingInfo: computed(() => waitlistData.value?.pricing_info || ''),
    }
  },
  data() {
    return {
      memberships: [],
    }
  },
  computed: {
    loggedIn() {
      return this.$auth.loggedIn
    },
    hasMembership() {
      let hasMembership = false
      this.memberships.forEach((m) => {
        hasMembership = m.plans.some((p) => p.is_member)
      })
      return hasMembership
    },
    isAccepted() {
      let isAccepted = false
      this.memberships.forEach((m) => {
        isAccepted = m.plans.some((p) => p.is_accepted)
      })
      return isAccepted
    },
    pageContent() {
      return (
        (this.memberships &&
          this.memberships[0] &&
          this.memberships[0].page_content) ||
        {}
      )
    },
  },
  watch: {
    async loggedIn(newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        await this.fetchMemberships()
      }
    },
  },
  mounted() {
    this.setup()
  },
  activated() {
    this.setup()
  },
  methods: {
    openLoginModal() {
      this.$auth.openAuthModal({
        redirect: '/waitlist/join/',
        isClub: true,
      })
    },
    setup() {
      this.memberships = []
      if (this.loggedIn) {
        this.fetchMemberships()
      }
      ga4.trackViewClub({ slug: 'waitlist' })
    },
    signup() {
      if (!this.$auth.loggedIn) {
        this.openLoginModal()
      } else {
        this.$router.push('/waitlist/join/')
      }
    },
    async fetchMemberships() {
      const result = await this.$axios.get('/api/membership/')
      this.memberships = result.data.memberships.filter(
        (m) => m.slug === 'waitlist',
      )
    },
  },
}
</script>
